<template>
  <div class="filter-wrapper">
    <div class="columns is-multiline">
      <div class="column is-one-quarter" v-for="meta in filterMeta" :key="meta.fieldId">
        <label v-if="meta.type !== 'bool'" class="label">!!{{ meta.label }}</label>
        <input v-if="meta.type === 'string'" class="input" type="text" :placeholder="meta.label" v-model.lazy="filter[meta.fieldId]" v-debounce="debounceDelay">
        <template v-else-if="meta.type === 'select'">
          <select class="input" v-model.lazy="filter[meta.fieldId]">
            <option :value="null">Alla</option>
            <option v-for="option in meta.options" :key="option.key" :value="option.key">{{ option.value }}</option>
          </select>
        </template>
        <template v-if="meta.type === 'bool'">
          <label class="label active-switch">&nbsp;</label>
          <input :id="'id-' + meta.fieldId" type="checkbox" :name="meta.fieldId" v-model.lazy="filter[meta.fieldId]" class="switch is-rounded active-switch">
          <label :for="'id-' + meta.fieldId" class="label active-switch">{{ meta.label }}</label>
        </template>
      </div>
      <div class="column is-one-fifth" >
        <label class="label">&nbsp;</label>
        <button class="button" @click="$emit('resetFilter')" v-if="filterMeta.length > 0">
          <span class="icon is-small">
            <i class="fal fa-undo"></i>
          </span>
          <span>Återställ</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterMeta: Array,
    filter: Object,
    defaultFilter: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      debounceDelay: process.env.DEBOUNCE_DELAY
    }
  },
  methods: {
    resetFilter () {
      this.$store.state[this.dataType].all.filter = Object.assign({}, this.defaultFilter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table/AgileTableFilters.vue